export default __webpack_public_path__ + "static/media/reception.ffad2e43.svg";